export default function Test() {
    return (
    <div className="afficheur">
      TESTAGE DE TRUC
    </div>
    );
}


